export const emailAndNotificationReducer = (
	state = {
		list: undefined,
		count: 0,
		data: [],
		details: undefined,
		detail: undefined,
	},
	action
) => {
	switch (action.type) {
		case "EMAIL_AND_NOTIFICATION_LIST_SUCCESS":
		case "EMAIL_AND_NOTIFICATION_SEARCH_SUCCESS":
			return {
				...state,
				list: action.payload.list,
				count: action.payload.count,
				data: action.payload.data,
			};
		case "EMAIL_AND_NOTIFICATION_DETAILS":
			return {
				...state,
				details: action.payload,
			};

		case "EMAIL_AND_NOTIFICATION_TOGGLE_SUCCESS":
			return {
				...state,
				details: { ...state?.details, isActive: !state?.details?.isActive },
			};
		case "EMAIL_AND_NOTIFICATION_SEARCH_CLEAR":
			return {
				...state,
				list: undefined,
				count: 0,
			};
		default:
			return state;
	}
};
